// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1_iHJ","cls2":"mentions_milestone_ping-cls2_GYv mentions_milestone_ping-cls1_iHJ"};